export default __webpack_public_path__ + "static/media/Simona Vinci.17a5ccde.jpg";